import { gsap } from "gsap";

function myBrowser() {
  const { userAgent } = navigator; // 取得浏览器的userAgent字符串
  const isOpera = userAgent.indexOf("Opera") > -1;
  if (isOpera) {
    return "Opera";
  } // 判断是否Opera浏览器
  if (userAgent.indexOf("Firefox") > -1) {
    return "FF";
  } // 判断是否Firefox浏览器
  if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  }
  if (userAgent.indexOf("Safari") > -1) {
    return "Safari";
  } // 判断是否Safari浏览器
  if (
    userAgent.indexOf("compatible") > -1 &&
    userAgent.indexOf("MSIE") > -1 &&
    !isOpera
  ) {
    return "IE";
  } // 判断是否IE浏览器
  return null;
}

const isSafari = myBrowser() === "Safari";
let loadedCompletedFlag = false;
function closeProgress() {
  if (loadedCompletedFlag) return;
  window.criticalResourceLoaded();
  loadedCompletedFlag = true;
}
const percentObj = {
  current: 0,
};
const dom = document.querySelector("#progressBar");
const tl = gsap.timeline({
  onUpdate: () => {
    if (!dom) return;
    const cssPercent = 100 - percentObj.current;
    dom.style.transform = `translateX(-${cssPercent}%)`;
  },
  onComplete: () => {
    if (percentObj.current > 95) {
      console.log("全部加载完毕！");
      closeProgress();
      tl.kill();
    }
  },
});

setTimeout(() => {
  // 超过15秒还没加载完毕，还是关掉进度条吧
  closeProgress();
}, 15 * 1000);
// 单位 KB
const map = new Map([
  ["js", { size: 2 * 1024 }], // 假设js等打包资源是2M大小
  ["first-screen.mp4", { size: 239.78 }],
]);

if (window.location.hash === "#/") {
  map.set("0.mp4", { size: 195 });
  map.set("1.mp4", { size: 315 });
  map.set("2.mp4", { size: 320 });
  map.set("3.mp4", { size: 99 });
  map.set("4.mp4", { size: 162 });
  // map.set("5.mp4", { size: 333 });
}

let totalSize = 0;
map.forEach((item) => {
  totalSize += item.size;
});

export default function criticalResourceLoad(
  fielName,
  seekableTime,
  bufferedTime
) {
  if (!document.querySelector("#progressBar")) return;
  const fileNames = [].concat(fielName);
  fileNames.forEach((fileName) => {
    const realFileName = fileName.substr(fielName.lastIndexOf("/") + 1);
    console.log("资源加载-->", realFileName);
    const obj = map.get(realFileName);
    if (!obj) return;
    if (isSafari && realFileName.indexOf("mp4") > -1) {
      // safari在加载视频的时候，页面太卡了，必须特殊处理下视频
      if (!seekableTime || !bufferedTime) return;
      map.get(realFileName).loaded = (bufferedTime / seekableTime) * obj.size;
    } else {
      map.get(realFileName).loaded = obj.size;
    }
  });
  let loadedSize = 0;
  map.forEach((item) => {
    loadedSize += item.loaded || 0;
  });
  const percent = (loadedSize / totalSize) * 100;
  // if (percent - percentObj.current < 0.001) return; // safari 莫名其妙地抖动
  // const cssPercent = Math.abs((1 - percent) * 100);
  console.log("ccccc---->", loadedSize, totalSize, percent);

  tl.clear();
  tl.to(percentObj, 0.5, {
    current: percent,
  });
}
criticalResourceLoad("js"); // 能进到这就说明js资源等都加载完毕了
